const LEGACY_DASHBOARD_WORKER_PATH = '/sw.js'
const LEGACY_DASHBOARD_CACHE_PREFIX = 'x3algo-dashboard-'
const RELOAD_GUARD_KEY = 'x3algo-dashboard-sw-cleanup-reload'

const getRegistrationWorkers = registration =>
  [registration.active, registration.waiting, registration.installing].filter(
    Boolean,
  )

const isLegacyDashboardWorker = (worker, origin) => {
  if (!worker?.scriptURL || !origin) return false

  try {
    const scriptUrl = new URL(worker.scriptURL)
    return (
      scriptUrl.origin === origin &&
      scriptUrl.pathname === LEGACY_DASHBOARD_WORKER_PATH
    )
  } catch {
    return false
  }
}

export const clearLegacyDashboardServiceWorker = async ({
  serviceWorker = globalThis.navigator?.serviceWorker,
  cacheStorage = globalThis.caches,
  location = globalThis.location,
  storage = globalThis.sessionStorage,
} = {}) => {
  const origin = location?.origin
  const controllingLegacyWorker = isLegacyDashboardWorker(
    serviceWorker?.controller,
    origin,
  )

  const registrations = serviceWorker?.getRegistrations
    ? await serviceWorker.getRegistrations()
    : []
  const legacyRegistrations = registrations.filter(registration =>
    getRegistrationWorkers(registration).some(worker =>
      isLegacyDashboardWorker(worker, origin),
    ),
  )

  const unregisterResults = await Promise.all(
    legacyRegistrations.map(registration => registration.unregister()),
  )

  if (cacheStorage?.keys) {
    const cacheNames = await cacheStorage.keys()
    await Promise.all(
      cacheNames
        .filter(cacheName =>
          cacheName.startsWith(LEGACY_DASHBOARD_CACHE_PREFIX),
        )
        .map(cacheName => cacheStorage.delete(cacheName)),
    )
  }

  const registrationRemoved = unregisterResults.some(Boolean)
  const alreadyReloaded = storage?.getItem(RELOAD_GUARD_KEY) === 'true'

  if (
    controllingLegacyWorker &&
    registrationRemoved &&
    !alreadyReloaded &&
    location?.reload
  ) {
    storage?.setItem(RELOAD_GUARD_KEY, 'true')
    location.reload()
    return true
  }

  storage?.removeItem(RELOAD_GUARD_KEY)
  return false
}
